(function (globalScope, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (globalScope) globalScope.CernirCustomStrapStitchingData = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const DATA = Object.freeze({
  "version": "demo-v1.0.0",
  "defaults": {
    "threadColour": null
  },
  "stitchingStyles": [
    {
      "id": "classic-stitches",
      "title": "Classic Stitches",
      "helperText": "One row around the edge.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "classic-stitches"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "no-stitches",
      "title": "No Stitches",
      "helperText": "No visible thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "no-stitches"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "presile-to-the-lugs",
      "title": "Side Stitch",
      "helperText": "Stitches at the watch end only.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "presile-to-the-lugs"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "box-stitches",
      "title": "Box Stitches",
      "helperText": "Stitched box at the watch end.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "box-stitches"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "classic-double-stitches",
      "title": "Double Stitches",
      "helperText": "Two parallel rows.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "classic-double-stitches"
      },
      "disabled": false,
      "priceModifier": null
    }
  ],
  "threadColours": [
    {
      "id": "tone-on-tone",
      "title": "Tone on Tone",
      "code": "Tone on tone (match leather)",
      "helperText": "Use Tone on Tone thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "tone-on-tone"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "black",
      "title": "Black",
      "code": "MS001",
      "helperText": "Use Black thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "black"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "dark-grey",
      "title": "Dark Grey",
      "code": "MS035",
      "helperText": "Use Dark Grey thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "dark-grey"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "grey",
      "title": "Grey",
      "code": "MS041",
      "helperText": "Use Grey thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "grey"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "silver",
      "title": "Silver",
      "code": "MS064",
      "helperText": "Use Silver thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "silver"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "white",
      "title": "White",
      "code": "MS007",
      "helperText": "Use White thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "white"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "ivory",
      "title": "Ivory",
      "code": "MS101",
      "helperText": "Use Ivory thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "ivory"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "cream",
      "title": "Cream",
      "code": "MS006",
      "helperText": "Use Cream thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "cream"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "beige",
      "title": "Beige",
      "code": "MS005",
      "helperText": "Use Beige thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "beige"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "camel",
      "title": "Camel",
      "code": "MS056",
      "helperText": "Use Camel thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "camel"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "taupe",
      "title": "Taupe",
      "code": "MS036",
      "helperText": "Use Taupe thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "taupe"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "cognac",
      "title": "Cognac",
      "code": "MS004",
      "helperText": "Use Cognac thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "cognac"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "chestnut",
      "title": "Chestnut",
      "code": "MS083",
      "helperText": "Use Chestnut thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "chestnut"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "coffee",
      "title": "Coffee",
      "code": "MS002",
      "helperText": "Use Coffee thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "coffee"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "olive",
      "title": "Olive",
      "code": "MS039",
      "helperText": "Use Olive thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "olive"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "grass-green",
      "title": "Grass Green",
      "code": "MS027",
      "helperText": "Use Grass Green thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "grass-green"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "forest-green",
      "title": "Forest Green",
      "code": "MS076",
      "helperText": "Use Forest Green thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "forest-green"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "bottle-green",
      "title": "Bottle Green",
      "code": "MS077",
      "helperText": "Use Bottle Green thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "bottle-green"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "turquoise",
      "title": "Turquoise",
      "code": "MS029",
      "helperText": "Use Turquoise thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "turquoise"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "slate-green",
      "title": "Slate Green",
      "code": "MS096",
      "helperText": "Use Slate Green thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "slate-green"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "classic-blue",
      "title": "Classic Blue",
      "code": "MS094",
      "helperText": "Use Classic Blue thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "classic-blue"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "dark-navy",
      "title": "Dark Navy",
      "code": "MS079",
      "helperText": "Use Dark Navy thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "dark-navy"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "navy",
      "title": "Navy",
      "code": "MS019",
      "helperText": "Use Navy thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "navy"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "blue",
      "title": "Blue",
      "code": "MS021",
      "helperText": "Use Blue thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "blue"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "bordeaux",
      "title": "Bordeaux",
      "code": "MS008",
      "helperText": "Use Bordeaux thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "bordeaux"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "plum",
      "title": "Plum",
      "code": "MS051",
      "helperText": "Use Plum thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "plum"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "dark-red",
      "title": "Dark Red",
      "code": "MS085",
      "helperText": "Use Dark Red thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "dark-red"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "red",
      "title": "Red",
      "code": "MS009",
      "helperText": "Use Red thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "red"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "scarlet",
      "title": "Scarlet",
      "code": "MS053",
      "helperText": "Use Scarlet thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "scarlet"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "magenta",
      "title": "Magenta",
      "code": "MS010",
      "helperText": "Use Magenta thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "magenta"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "pink",
      "title": "Pink",
      "code": "MS012",
      "helperText": "Use Pink thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "pink"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "rose-pink",
      "title": "Rose Pink",
      "code": "MS013",
      "helperText": "Use Rose Pink thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "rose-pink"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "orange",
      "title": "Orange",
      "code": "MS015",
      "helperText": "Use Orange thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "orange"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "banana",
      "title": "Banana",
      "code": "MS017",
      "helperText": "Use Banana thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "banana"
      },
      "disabled": false,
      "priceModifier": null
    },
    {
      "id": "golden-yellow",
      "title": "Golden Yellow",
      "code": "MS016",
      "helperText": "Use Golden Yellow thread.",
      "image": null,
      "thumbnail": {
        "kind": "diagram",
        "variant": "golden-yellow"
      },
      "disabled": false,
      "priceModifier": null
    }
  ],
  "threadColourActiveUnless": {
    "stitchingStyle": "no-stitches"
  }
});

  function getOptions(field) {
    if (field === 'stitchingStyle') return DATA.stitchingStyles;
    if (field === 'threadColour') return DATA.threadColours;
    return [];
  }

  function getThreadColourQuickOptions() {
    return ['tone-on-tone', 'cream'].map((id) => getOption('threadColour', id)).filter(Boolean);
  }

  function getCustomThreadColours() {
    const quickIds = new Set(getThreadColourQuickOptions().map((item) => item.id));
    return DATA.threadColours.filter((item) => !quickIds.has(item.id));
  }

  function getOption(field, optionId) {
    return getOptions(field).find((item) => item.id === optionId && !item.disabled) || null;
  }

  function isThreadColourActive(stitchingStyle) {
    return stitchingStyle !== DATA.threadColourActiveUnless.stitchingStyle;
  }

  return Object.freeze({ DATA, getOptions, getOption, getThreadColourQuickOptions, getCustomThreadColours, isThreadColourActive });
});
